export const ADMIN_PERMISSIONS = {
  CREATE_ADMINS: 'create_admins',
  VIEW_ADMINS: 'view_admins',
  EDIT_ADMINS: 'edit_admins',
  DELETE_ADMINS: 'delete_admins',

  CREATE_DRIVERS: 'create_drivers',
  VIEW_DRIVERS: 'view_drivers',
  EDIT_DRIVERS: 'edit_drivers',
  DELETE_DRIVERS: 'delete_drivers',

  CREATE_ORDERS: 'create_orders',
  VIEW_ORDERS: 'view_orders',
  VIEW_ALL_ORDERS: 'view_all_orders',
  EDIT_ORDERS: 'edit_orders',
  DELETE_ORDERS: 'delete_orders',
  UPDATE_ORDER_STATUS: 'update_order_status',

  VIEW_DISPATCH: 'view_dispatch',
  EDIT_DISPATCH: 'edit_dispatch',

  VIEW_SETTINGS: 'view_settings',
  MANAGE_SETTINGS: 'manage_settings',

  MANAGE_ORDER_CUSTOM_FIELDS: 'manage_order_custom_fields',
  MANAGE_ORDER_STATUSES: 'manage_order_statuses',

  CREATE_PRODUCTS: 'create_products',
  VIEW_PRODUCTS: 'view_products',
  EDIT_PRODUCTS: 'edit_products',
  DELETE_PRODUCTS: 'delete_products',
  EDIT_STOCK: 'edit_stock',
  EDIT_PAYMENT_TYPE: 'edit_payment_type',
  VIEW_EVENT_LOGS: 'view_event_logs',
  VIEW_REPORTS: 'view_reports',

  VIEW_BANNERS: 'view_banners',
  CREATE_BANNERS: 'create_banners',
  EDIT_BANNERS: 'edit_banners',
  DELETE_BANNERS: 'delete_banners',

  VIEW_REEL_VIDEOS: 'view_reel_videos',
  CREATE_REEL_VIDEOS: 'create_reel_videos',
  EDIT_REEL_VIDEOS: 'edit_reel_videos',
  DELETE_REEL_VIDEOS: 'delete_reel_videos',
};

/** Display names for permissions whose label should not be derived from the key. */
export const PERMISSION_LABELS = {
  [ADMIN_PERMISSIONS.VIEW_ALL_ORDERS]: "View Everyone's Order",
  [ADMIN_PERMISSIONS.VIEW_REPORTS]: 'View Reports',
};
